<template>
    <div class="page-heading">
        <h2 class="display-4 montserrat-bold text-capitalize" v-text="pageTitle"></h2>
        <div class="mt--2 mb-4 heading-small booking-nav">
            <div class="row">
                <div v-for="(item, key) in items" :key="key" :class="navigationClass(item)">
                    <div class="content-wrapper text-capitalize">
                        <span class="numeric-bullet mr-2" v-text="key + 1"></span> {{ getDisplayName(item) }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "BookingNavigation",

    computed: {
        pageTitle() {
            return this.title ? `Create Booking - ${ this.title }` : "Create Booking";
        }
    },

    methods: {
        getDisplayName(name) {
            return name ? name.replace("_", " ") : "";
        },
        
        navigationClass(item) {
            return item == this.activeItem ? "col-3 booking-nav-item active" : "col-3 booking-nav-item";
        }
    },

    props: {
        activeItem: String,
        title: String,
        items: Array,
    }
}
</script>
<style lang="css" scoped>
    .booking-nav::before {
        content: " ";
        display: block;
        z-index: 1;
        border: 1px solid #b5b6b7;
        border-width: 1px 0 0 0;
        top: 9px;
        position: relative;
    }
    .booking-nav-item {
        color: #555555 !important;
        z-index: 5;
    }
    .booking-nav-item:not(.active) {
        color: #b5b6b7 !important;
    }
    .booking-nav-item .numeric-bullet {
        border-radius: 50%;
        color: #f5f6f8;
        background-color: #555555;
        padding: 0px 5px;
        display: inline-block;
        font-weight: 500;
    }
    .booking-nav-item:not(.active) .numeric-bullet {
        background-color: #b5b6b7 !important;
    }
    .booking-nav-item .content-wrapper {
        padding: 0px 5px;
        background-color: #f5f6f8;
        display: inline-block;
    }
</style>